import DynamicArea from './DynamicArea';

const dynamicAreas = document.querySelectorAll('[data-dynamic-area]');

dynamicAreas.forEach((area) => new DynamicArea(area));
